import React from 'react';
import possibilityImage from '../../assets/possibility.svg';

import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      
      <h1 className="gradient__text">Empowered by unity and teamwork</h1>
      <p>Owing to the generous support from our collaborators, our success is motley mixtures of sheer teamwork, persistence, and resilience. These ensure our stellar performance.</p>
      {/*<h4>Request Early Access to Get Started</h4>*/}
    </div>
   
     
  </div>
  
);

export default Possibility;